import type { SVGProps } from 'react'
const SvgSyBellPin = (props: SVGProps<SVGSVGElement>) => (
	<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width={24} height={24} {...props}>
		<path
			fillOpacity={0.24}
			fillRule="evenodd"
			d="M12 2a6 6 0 0 0-6 6v1.831a7.83 7.83 0 0 1-1.116 4.029l-.553.922c-.367.612-.551.918-.564 1.168a1 1 0 0 0 .528.932c.221.118.578.118 1.291.118h12.828c.713 0 1.07 0 1.29-.118a1 1 0 0 0 .529-.932c-.013-.25-.197-.556-.564-1.168l-.553-.922A7.83 7.83 0 0 1 18 9.83v-.514c0-.164 0-.246-.047-.29s-.137-.04-.317-.03Q17.57 9 17.5 9a2.5 2.5 0 0 1-1.266-4.656c.177-.104.265-.156.275-.228s-.052-.137-.177-.267A5.98 5.98 0 0 0 12 2"
			clipRule="evenodd"
		/>
		<circle cx={17.5} cy={6.5} r={1.5} />
		<path d="M14.35 18a.14.14 0 0 1 .143.15c-.045.475-.3.925-.725 1.264-.47.375-1.105.586-1.768.586s-1.299-.21-1.768-.586c-.424-.34-.68-.789-.725-1.264A.14.14 0 0 1 9.65 18H12z" />
	</svg>
)
export default SvgSyBellPin
